<script>
export default {
  name: "CustomPagination",
  props: {
    /**
     * ページ番号
     */
    pageNumber: {
      type: Number,
      default: () => 0,
    },
    /**
     * 一覧表示件数
     */
    perPage: {
      type: Number,
      default: () => 50,
    },
    /**
     * 表示可能なpaginationの最大数
     */
    totalVisible: {
      type: Number,
      default: () => null,
    },
    /**
     * サーバーから取得したページネーションオブジェクト
     */
    pagination: {
      type: Object,
      default: () => {},
    },
    /**
     * ページごとの表示件数の選択肢
     */
    pageOptions: {
      type: Array,
      default: () => [15,30,50,100],
    },
  },
  data() {
    return {
      pages: this.pageOptions
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    /**
     * ページ番号 チェンジインベント
     * @param page {number}
     */
    changePage(page) {
      this.$emit("pageChanged", page)
    },
    /**
     * 表示件数 チェンジイベント
     * @param perPage {number}
     */
    changePerPageEvent(perPage) {
      this.$emit("perPageChanged", perPage)
    }
  }
}
</script>

<template>
  <v-sheet>
    <v-row>
      <v-col cols="12" md="12">
        <div class="pagination-layout">
          <span class="mt-3 mr-2">全{{ pagination.total_count | comma_format }}&nbsp;件</span>
          <v-select
            :model-value="perPage"
            :value="perPage"
            :items="pages"
            label="一覧表示件数"
            hide-details="auto"
            :outlined="true"
            :dense="true"
            style=""
            class="perPageSelector"
            @change="changePerPageEvent"
          />
          <v-pagination
            :model-value="pageNumber"
            :value="pageNumber"
            :length="pagination.total_pages"
            :total-visible="totalVisible"
            circle
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="changePage"
          />
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<style scoped lang="scss">

</style>
